import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=11884f08&scoped=true&"
import script from "./index3.vue?vue&type=script&lang=js&"
export * from "./index3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11884f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11884f08')) {
      api.createRecord('11884f08', component.options)
    } else {
      api.reload('11884f08', component.options)
    }
    module.hot.accept("./index3.vue?vue&type=template&id=11884f08&scoped=true&", function () {
      api.rerender('11884f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/userLists/index3.vue"
export default component.exports